// extracted by mini-css-extract-plugin
export default {"footerMenuBar":"Footer_footerMenuBar__gzeGT","footerMenu":"Footer_footerMenu__80vKm"};